import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, Events } from 'ionic-angular';
import { BillingPaymentsProvider } from '../../providers/billing-payments/billing-payments';
import { ToastProvider } from '../../providers/toast/toast';
import { LoginProvider } from '../../providers/login/login';
import { InAppBrowserObject } from '@ionic-native/in-app-browser';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-make-payment',
  templateUrl: 'make-payment.html',
})
export class MakePaymentPage {

  billTypes = [];
  billType: any;
  amount: number;
  outstanding: any;
  invalidAmount = false;
  minPayble: any;
  maxPayble: any;
  message = "";
  billTypeObj;
  fixedAmount;
  isEditable = true;
  remarks: any;
  decimalPlaces: number;
  pmtValidations;
  payRemarks = "";

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private bpProvider: BillingPaymentsProvider,
    private toast: ToastProvider,
    private translate: TranslateService,
    public events: Events,
    private viewCtrl: ViewController,
    private loginProvider: LoginProvider) {
    this.outstanding = (this.navParams.get('outstanding'))?this.navParams.get('outstanding'):null;
    if(!this.outstanding){
      bpProvider.getOutstandings(1).then(val => {
        if(val.status == "success"){
          this.outstanding = val.data;
        }
      });
    }
    bpProvider.getBillTypes().then(val => {
      this.billTypes = Array.from(val.values());
      if(this.billTypes[0].id == 0){
        this.billType = 0;
      }else{
        let myPlan = this.outstanding.map(e => e.id);
        this.billTypes = this.billTypes.filter(e=>{return myPlan.includes(e.id);})
      }
      if(this.navParams.get("billType")){
        this.billType = this.navParams.get("billType");
        this.setBillTypeAndConfig();
        this.onChange(this.billType);
      }
      this.setAmount();
    });
  }

  setBillTypeAndConfig(){
    this.pmtValidations = null;
    this.minPayble = null;
    this.fixedAmount = null;
    this.maxPayble = null;
    this.isEditable = true;
    this.remarks = null;
    this.decimalPlaces = 0;
    this.billTypeObj = this.bpProvider.getBillTypeObj(+this.billType);
    if(this.billTypeObj.custom_bill_config){
      try{
        let customBillConfig = JSON.parse(this.billTypeObj.custom_bill_config);
        if(customBillConfig.pmt_validations){
          this.pmtValidations = customBillConfig.pmt_validations;
          this.minPayble = (customBillConfig.pmt_validations.min)?+customBillConfig.pmt_validations.min:null;
          this.maxPayble = (customBillConfig.pmt_validations.max)?+customBillConfig.pmt_validations.max:null;
          this.fixedAmount = (customBillConfig.pmt_validations.fixed_amounts)?customBillConfig.pmt_validations.fixed_amounts:null;
          this.isEditable = (customBillConfig.pmt_validations.is_editable == "0")?false:true;
          this.remarks = customBillConfig.pmt_validations.remarks;
          this.decimalPlaces = (customBillConfig.pmt_validations.decimal)?customBillConfig.pmt_validations.decimal:0;
        }
      }catch(e){
        console.log(e);
      }
    }
  }

  setAmount(){
    if(this.navParams.get("amount")){
      let amount = this.navParams.get("amount");
      if(amount && amount<0){
        this.amount = 0;
      }else{
        this.amount = +(+amount).toFixed(this.decimalPlaces);
      }
      this.amountChange();
    }
  }

  onPay(){
    if(this.billType || this.billType == 0){
      if(this.amount>0){
        if(this.billType.id == 'AMENITY_BOOKING'){
          if(this.payRemarks){
            this.payRemarks = this.payRemarks +"-"+ this.billType.amenity.name +":"+this.billType.amenity.fromDate
          }else{
            this.payRemarks = this.billType.amenity.name +":"+this.billType.amenity.fromDate
          }
            
        }
          
        if(this.pmtValidations){
          this.bpProvider.validateRecharge(this.amount, this.billType).then(val => {
            if(val.status == 'success'){
              this.bpProvider.makePayment(this.amount,this.billType, this.payRemarks);
              this.dismiss();
            }else{
              this.invalidAmount = true;
              this.message = val.message;
              this.toast.presentToast(val.message);
            }
          });
        }else{
          this.bpProvider.makePayment(this.amount,this.billType, this.payRemarks);
          this.dismiss();
        }
      }else{
        this.toast.presentToast("Please fill some amount");
      }
    }else{
      this.toast.presentToast("Select a bill type");
    }
  }

  onChange(billType){
    this.setBillTypeAndConfig();
    if(this.outstanding){
      let flag = 0;
      this.outstanding.forEach(outstanding => {
        if(outstanding.id == billType){
          if(outstanding.show_bal)
            this.amount = +(+outstanding.data.balance).toFixed(this.decimalPlaces);
          else
            this.amount = (this.minPayble)?this.minPayble:1;
          flag = 1;
        }
      });
      if(flag == 0 || this.amount<0){
        this.amount = (this.minPayble)?this.minPayble:1;
      }
    }
    this.amountChange();
  }

  amountChange(amount?: number){
    if(amount)
      this.amount = amount;
    if(typeof this.minPayble == "string" || typeof this.minPayble == "number"){
      if(this.amount<this.minPayble){
        this.invalidAmount = true;
        this.message = `Min amount payable is ${this.minPayble}`;
      }else if(typeof this.maxPayble == "string" || typeof this.maxPayble == "number"){
        if(this.amount>this.maxPayble){
          this.invalidAmount = true;
          this.message = `Max amount payable is ${this.maxPayble}`;
        }else{
          this.invalidAmount = false;
          this.message = "";
        }
      }else{
        this.invalidAmount = false;
        this.message = "";
      }
    }else{
      this.invalidAmount = false;
      this.message = "";
    }
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MakePaymentPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/make-payment/make-payment.ts